// toastService.js
let externalShowToast = null;

export const registerToast = (fn) => {
  externalShowToast = fn;
};

export const showGlobalToast = (message, type = 'info', duration = 3000) => {
  if (externalShowToast) {
    externalShowToast(message, type, duration);
  } else {
    console.warn('Toast system not ready');
  }
};
